export const BASE_PATH_SERVER = import.meta.env.VITE_API_URL;
export const patchEslint = true;
